import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styles from "./Spinner.module.scss";

const Spinner = () => {
  const [showSVG, setShowSVG] = useState(true);
  const isLoading = useSelector((state) => state.authReducer.isLoading);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowSVG(false);
      setTimeout(() => {
        setShowSVG(true);
      }, 100); // Brief removal to force re-render
    }, 4000); // Every 4 seconds

    return () => clearInterval(interval);
  }, []);

  if (!isLoading) return null;

  return (
    <div className={styles.Spinner}>
      {showSVG && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="86"
          height="68"
          viewBox="0 0 86 68"
          fill="none"
        >
          <path
            className={styles.pathTop}
            d="M1.00495 31.4309C6.86449 21.5472 22.4542 12.5479 33.82 12.5479L42.7929 21.5182L51.7621 12.5479C63.1278 12.5479 78.7213 21.5472 84.5814 31.4309H85.5863C79.8873 13.2173 62.8855 0 42.7934 0C22.7014 0 5.69904 13.2173 0 31.4309H1.00495Z"
            fill="#D8DBDE"
          />
          <path
            className={styles.pathMiddle}
            d="M42.792 30.8242C54.7734 30.8242 64.9123 38.4405 68.3106 49.5295H67.7112C60.732 41.9385 51.668 38.6721 42.792 38.6721C33.9155 38.6721 24.8521 41.9385 17.8729 49.5295H17.2734C20.6718 38.4405 30.8107 30.8242 42.792 30.8242Z"
            fill="#D8DBDE"
          />
          <path
            className={styles.pathBottom}
            d="M49.1843 61.6081L42.793 55.2168L36.4017 61.6081L42.793 67.9994L49.1843 61.6081Z"
            fill="#D8DBDE"
          />
        </svg>
      )}
    </div>
  );
};

export default Spinner;
